import { EChatCustomActionModalActionTypes } from '../../actions/chatCustomActionModal';
import { TAppState } from '../../types/appState';
import { TReduxActions } from '../../types/redux/actions';

export const chatCustomActionModalReducer = (state: TAppState, action: TReduxActions): TAppState => {
  switch (action.type) {
    case EChatCustomActionModalActionTypes.Show:
      return {
        ...state,
        chatCustomActionModal: {
          isOpened: true,
          ...action.payload,
        },
      };

    case EChatCustomActionModalActionTypes.Hide:
      return {
        ...state,
        chatCustomActionModal: {
          isOpened: false,
        },
      };

    default:
      return state;
  }
};
